/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcSweepsClearingV1SweepParticipantState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_SWEEPS_CLEARING_V1_SWEEP_PARTICIPANT_STATE_ENTITY_NAME = 'ixc.sweeps.clearing.v1.SweepParticipant';
export const ixcSweepsClearingV1SweepParticipantStateEntity = new schema.Entity<IxcSweepsClearingV1SweepParticipantState>(IXC_SWEEPS_CLEARING_V1_SWEEP_PARTICIPANT_STATE_ENTITY_NAME, {}, { idAttribute: 'accountId' });

